import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import s from './Topbar.module.css';
import { Icon } from './Icon';
import { detectCurrentService, readStickyService } from './services';
export function Topbar({ onSidebarOpen }) {
    const { pathname } = useLocation();
    const service = detectCurrentService(pathname, readStickyService());
    return (_jsxs("header", { className: s.root, children: [_jsx("button", { type: "button", className: s.menuBtn, "aria-label": "Open sidebar", onClick: onSidebarOpen, children: _jsx(Icon, { name: "menu", size: 22 }) }), _jsx("div", { className: s.brand, children: service.name })] }));
}
